import Moment from "react-moment";
import i18next from 'i18next';

const MessageDate = ({message, now}) => {
    const messageTime = message.ts_in_messenger * 1000;
    const messageDate = message.ts_in_messenger ? new Date(messageTime) : new Date();
    const lang = i18next.language;

    if (now.getDate() === messageDate.getDate() && (now - messageDate) < 24 * 60 * 60 * 1000) {
        return <Moment locale={lang} format="HH:mm">{messageTime}</Moment>
    } else {
        return <>
            <Moment locale={lang} format={now.getFullYear() === messageDate.getFullYear() ? "DD MMM" : "DD MMM YYYY"} style={{fontSize: '.6rem'}}>
                {messageTime}
            </Moment>
            &nbsp;&nbsp;
            <Moment locale={lang} format="HH:mm">{messageTime}</Moment>
        </>;
    }
}

export default MessageDate;